import type { AnalyticsEventPayload, UIAnalyticsEvent } from '@atlaskit/analytics-next';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { isHttpClientErrorResponse } from '@atlassian/jira-fetch/src/utils/is-error.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge/src/utils/fire-analytics';
import { teamName, packageName } from '../../common/constants.tsx';
import type { ProformaReqTypeFormAddRequest } from './types.tsx';

export const addProformaReqTypeForm = async ({
	cloudId,
	projectId,
	requestTypeId,
	formId,
	createAnalyticsEvent,
}: ProformaReqTypeFormAddRequest & {
	createAnalyticsEvent?: (payload: AnalyticsEventPayload) => UIAnalyticsEvent;
}): Promise<number> => {
	try {
		await performPostRequest(
			`/gateway/api/proforma/cloudid/${cloudId}/api/3/project/${projectId}/requesttype/${requestTypeId}/form/${formId}/portal-association`,
		);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		if (!isHttpClientErrorResponse(error)) {
			fireErrorAnalytics({
				meta: {
					id: 'addProformaReqTypeForm',
					packageName,
					teamName,
				},
				error,
				attributes: {
					formId,
				},
			});
		}
		throw error;
	}

	createAnalyticsEvent &&
		fireTrackAnalytics(createAnalyticsEvent({}), 'proformaRTCFormAdd succeeded', {
			formId,
			projectId,
			requestTypeId,
		});
	return requestTypeId;
};
